import coreApi from '@/services/coreApi'
import {
  IConexaDataPageable,
  IConexaResponse,
  IConexaResponsePageable,
  IEnumResponse,
  IQueryParams,
} from '@/types'
import {
  ClinicListData,
  ClinicListDataMapper,
} from './mapper/AppointmentRequestMapper/ClinicListMapper/ClinicListMapper.types'
import ClinicListMapper from './mapper/AppointmentRequestMapper/ClinicListMapper/ClinicListMapper'
import qs from 'qs'
import ClinicParamsMapper from './mapper/AppointmentRequestMapper/ClinicParamsMapper/ClinicParamsMapper'
import PatientListMapper from './mapper/AppointmentRequestMapper/PatientListMapper.ts/PatientListMapper'
import {
  PatientListData,
  PatientListDataMapper,
} from './mapper/AppointmentRequestMapper/PatientListMapper.ts/PatientListMapper.types'
import SpecialtyListMapper from './mapper/AppointmentRequestMapper/SpecialtyListMapper/SpecialtyListMapper'
import {
  SpecialtyListData,
  SpecialtyListDataMapper,
} from './mapper/AppointmentRequestMapper/SpecialtyListMapper/SpecialtyListMapper.types'
import SubmitScheduleAppointmentMapper from './mapper/AppointmentRequestMapper/SubmitScheduleAppointmentMapper/SubmitScheduleAppointmentMapper'
import CreateAppointmentMapper from './mapper/AppointmentRequestMapper/CreateAppointmentMapper/CreateAppointmentMapper'
import { CreateAppointmentDataDomain } from './mapper/AppointmentRequestMapper/CreateAppointmentMapper/CreateAppointmentMapper.types'
import {
  CommunicationLogsResponse,
  GetCommunicationLogsResponse,
  AppointmentLogsListDataMapper,
  GetAppointmentListMapper,
  SubmitScheduleAppointment,
  RemoveAttachmentData,
  SendAttachment,
  CancelHistoryAppointmentPayload,
  UpdaterContactPayload,
  GetProfessionalByPatient,
  GetProfessionalByPatientResponse,
} from './TelemedicineServices.types'
import { DataFormatted } from '../store/ScheduleAppointment/ScheduleAppointment.types'
import {
  HealthInsuranceCardData,
  HealthInsuranceCardDataMapper,
} from './mapper/AppointmentRequestMapper/HealthInsuranceCardMapper/HealthInsuranceCardMapper.types'
import HealthInsuranceCardMapper from './mapper/AppointmentRequestMapper/HealthInsuranceCardMapper/HealthInsuranceCardMapper'
import ProfessionalListMapper from './mapper/ProfessionalListMapper/ProfessionalListMapper'
import ResponsibleListMapper from './mapper/AppointmentRequestMapper/ResponsibleListMapper/ResponsibleListMapper'
import {
  ResponsibleListData,
  ResponsibleListDataMapper,
} from './mapper/AppointmentRequestMapper/ResponsibleListMapper/ResponsibleListMapper.types'
import { CommunicationLogsSearchParams } from './mapper/CommunicationLogsMapper/CommunicationLogsSearchMapper/CommunicationLogsSearchMapper.types'
import CommunicationLogsSearchMapper from './mapper/CommunicationLogsMapper/CommunicationLogsSearchMapper/CommunicationLogsSearchMapper'
import CommunicationLogsDataMapper from './mapper/CommunicationLogsMapper/CommunicationLogsDataMapper/CommunicationLogsDataMapper'
import AppointmentLogsListMapper from './mapper/AppointmentLogsListMapper/AppointmentLogsListMapper/AppointmentLogsListMapper'
import { MedicalRecordData } from '../pages/MedicalRecord/components/MedicalRecordSearch/MedicalRecordSearch.types'
import {
  MedicalRecordProfessionalListData,
  MedicalRecordSpecialtiesListData,
} from '../pages/MedicalRecord/components/MedicalRecordFilter/MedicalRecordFilter.types'
import MedicalRecordProfessionalFilterMapper from './mapper/MedicalRecordMapper/MedicalRecordProfessionalFilterMapper/MedicalRecordProfessionalFilterMapper'
import { MedicalRecordProfessionalFilterDataMapper } from './mapper/MedicalRecordMapper/MedicalRecordProfessionalFilterMapper/MedicalRecordProfessionalFilterMapper.types'
import MedicalRecordParamsMapper from './mapper/MedicalRecordMapper/MedicalRecordParamsMapper/MedicalRecordParamsMapper'
import { SendReportsPayload } from '../pages/MedicalRecord/components/SendMedicalRecordsModal/SendMedicalRecordsModal.types'
import { downloadFiles } from '@/utils/downloadFiles'
import { MedicalRecordListDataMapper } from './mapper/MedicalRecordMapper/MedicalRecordListMapper/MedicalRecordListMapper.types'
import MedicalRecordListMapper from './mapper/MedicalRecordMapper/MedicalRecordListMapper/MedicalRecordListMapper'
import {
  ExportLogsData,
  ExportLogsDataMapper,
} from './mapper/ExportLogsMapper/ExportLogsMapper.types'
import ExportLogsListMapper from './mapper/ExportLogsMapper/ExportLogsListMapper'
import SendMedicalRecordsMapper from './mapper/MedicalRecordMapper/SendMedicalRecordsMapper/SendMedicalRecordsMapper'
import ImmediateAppointmentsQueueMapper from './mapper/AppointmentQueue/ImmediateAppointmentQueueMapper/ImmediateAppointmentsQueueMapper'
import ScheduledAppointmentsQueueMapper from './mapper/ScheduledAppointmentQueueMapper/ScheduledAppointmentQueueMapper'
import { ImmediateAppointmentQueueMapper } from './mapper/AppointmentQueue/ImmediateAppointmentQueueMapper/ImmediateAppointmentQueueMapper.types'
import { GetAppointmentsQueuesParams } from '../queries/AppointmentQueue/AppointmentQueue.types'
import { ScheduledAppointmentQueueMapper } from './mapper/ScheduledAppointmentQueueMapper/ScheduledAppointmentQueueMapper.types'
import ProfessionalListAppointmentQueueMapper from './mapper/AppointmentQueue/ProfessionalListAppointmentQueueMapper/ProfessionalListAppointmentQueueMapper'
import {
  ProfessionalListAppointmentQueueData,
  ProfessionalListAppointmentQueueDataMapper,
} from './mapper/AppointmentQueue/ProfessionalListAppointmentQueueMapper/ProfessionalListAppointmentQueueMapper.types'
import { CreateAppointmentQueueData } from './mapper/AppointmentQueue/CreateAppointmentQueueMapper/CreateAppointmentQueueMapper.types'
import CreateAppointmentQueueMapper from './mapper/AppointmentQueue/CreateAppointmentQueueMapper/CreateAppointmentQueueMapper'
import { AssignProfessionalDomainPayload } from './mapper/AppointmentQueue/AssignProfessionalMapper/AssignProfessionalMapper.types'
import AssignProfessionalMapper from './mapper/AppointmentQueue/AssignProfessionalMapper/AssignProfessionalMapper'
import GetAttachmentsMapper from './mapper/AppointmentQueue/GetAttachmentsMapper/GetAttachmentsMapper'
import { GetAttachmentsDataMapper } from './mapper/AppointmentQueue/GetAttachmentsMapper/GetAttachmentsMapper.types'
import HistoryAppointmentListMapper from './mapper/HistoryAppointmentMapper/HistoryAppointmentListMapper/HistoryAppointmentListMapper'
import {
  HistoryAppointmentData,
  HistoryAppointmentDataMapper,
  HistoryAppointmentParamsMapper,
} from './mapper/HistoryAppointmentMapper/HistoryAppointmentListMapper/HistoryAppointmentListMapper.types'
import CancelHistoryAppointmentMapper from './mapper/HistoryAppointmentMapper/CancelHistoryAppointmentMapper/CancelHistoryAppointmentMapper'
import ResendDocumentsMapper from './mapper/HistoryAppointmentMapper/ResendDocumentsMapper/ResendDocumentsMapper'
import {
  ResendDocumentsData,
  ResendDocumentsDataMapper,
} from './mapper/HistoryAppointmentMapper/ResendDocumentsMapper/ResendDocumentsMapper.types'
import AvailableHoursMapper from './mapper/HistoryAppointmentMapper/AvailableHoursMapper/AvailableHoursMapper'
import { AvailableHoursDataMapper } from './mapper/HistoryAppointmentMapper/AvailableHoursMapper/AvailableHoursMapper.types'
import RescheduleAppointmentMapper from './mapper/HistoryAppointmentMapper/RescheduleAppointmentMapper/RescheduleAppointmentMapper'
import { RescheduleAppointmentDataMapper } from './mapper/HistoryAppointmentMapper/RescheduleAppointmentMapper/RescheduleAppointmentMapper.types'
import AvailableHoursPVMapper from './mapper/HistoryAppointmentMapper/AvailableHoursPVMapper/AvailableHoursPVMapper'
import { AvailableHoursPVDataMapper } from './mapper/HistoryAppointmentMapper/AvailableHoursPVMapper/AvailableHoursPVMapper.types'
import {
  MedicalReferralDetailsData,
  MedicalReferralDetailsDataMapper,
} from './mapper/MedicalReferralDetailsMapper/MedicalReferralDetailsMapper.types'
import MedicalReferralDetailsMapper from './mapper/MedicalReferralDetailsMapper/MedicalReferralDetailsMapper'
import GetAppointmentsQueueListMapper from './mapper/AppointmentQueue/GetAppointmentsQueueListMapper/GetAppointmentsQueueListMapper'
import ContactListMapper from './mapper/AppointmentRequestMapper/ContactListMapper/ContactListMapper'
import ConfirmAppointmentMapper from './mapper/HistoryAppointmentMapper/ConfirmAppointmentMapper/ConfirmAppointmentMapper'
import { ConfirmAppointmentPayload } from './mapper/HistoryAppointmentMapper/ConfirmAppointmentMapper/ConfirmAppointment.types'
import { ClinicConfigTypes } from '@/modules/Users/services/mapper/PatientsMapper/ClinicConfigMapper/ClinicConfig.types'
import ClinicConfigMapper from '@/modules/Users/services/mapper/PatientsMapper/ClinicConfigMapper/ClinicConfigMapper'
import { PsychologistSearchFiltersData } from '@/modules/Users/services/mapper/PatientsMapper/PsychologistSearchFiltersMapper/PsychologistSearchFiltersMapper.types'
import PsychologistSearchFiltersMapper from '@/modules/Users/services/mapper/PatientsMapper/PsychologistSearchFiltersMapper/PsychologistSearchFiltersMapper'
import {
  DaySlotSchedule,
  PsyAliveListParams,
  PsyAliveListResponse,
  UsePsyScheduleParams,
} from './mapper/PsyAliveListMapper'
import { PsyScheduleMapper } from './mapper/PsyAliveListMapper/PsyAliveListMapper'
import MedicalRecordReportMapperTypes from './mapper/MedicalRecordMapper/MedicalRecordReportMapper/MedicalRecordReportMapper'
import { MedicalRecordReportFormData } from '../pages/MedicalRecord/MedicalRecordReport/MedicalRecordReport.types'
import MedicalRecordReportDownloadMapper from './mapper/MedicalRecordMapper/MedicalRecordReportMapper/MedicalRecordReportDownloadMapper'
import printoutAPI from '@/services/printoutApi'
import ForwardingListMapper from './mapper/ForwardingList/ForwardingListMapper'
import {
  ForwardingDataItem,
  ForwardingDataItemRaw,
  ForwardingListParamsRaw,
} from './mapper/ForwardingList/ForwardingListMapper.types'
import {
  DaySlotProfessionalSchedule,
  ProfessionalScheduleParams,
  ProfessionalsParams,
  ProfessionalsResponse,
} from './mapper/ProfessionalsMapper'

class TelemedicineServices {
  static async getClinicList(
    clinicName: string,
  ): Promise<ClinicListDataMapper[]> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<ClinicListData[]>>(
      `clinica/autocomplete/${clinicName}`,
    )

    return object.map(ClinicListMapper.toDomain)
  }

  static async getPatientList(
    queryParams?: IQueryParams,
  ): Promise<PatientListDataMapper[]> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<PatientListData[]>>(
      `paciente/agendamento/backoffice/autocomplete`,
      {
        params: ClinicParamsMapper.toPersistence(queryParams),
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'comma', encode: false })
        },
      },
    )

    return object.map(PatientListMapper.toDomain)
  }

  static async getMedicalRecordPatientList(
    queryParams?: IQueryParams,
  ): Promise<PatientListDataMapper[]> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<PatientListData[]>>(
      `paciente/prontuario/backoffice/autocomplete`,
      {
        params: ClinicParamsMapper.toPersistence(queryParams),
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'comma', encode: false })
        },
      },
    )
    return object.map(PatientListMapper.toDomain)
  }

  static async getObjectiveAppointmentList(
    queryParams: IQueryParams,
  ): Promise<IEnumResponse[]> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<IEnumResponse[]>>(
      `unified-appointment/enums/appointment-objectives/scheduling-backoffice`,
      {
        params: queryParams,
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'comma', encode: false })
        },
      },
    )

    return object
  }

  static async getPsychologistSearchFilters(): Promise<PsychologistSearchFiltersData> {
    const {
      data: { object },
    } = await coreApi.get('pv/psicologos/filtros/v1')

    return PsychologistSearchFiltersMapper.toDomain(object)
  }

  static async getClinicConfig(clinicId: number): Promise<ClinicConfigTypes> {
    const {
      data: { object },
    } = await coreApi.get(`clinica/config/${clinicId}`)

    return ClinicConfigMapper.toDomain(object)
  }

  static async getProfessionalTypeList(
    queryParams?: IQueryParams,
  ): Promise<IEnumResponse[]> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<IEnumResponse[]>>(
      `profissional/agendamento/backoffice/enums/tipo-profissional`,
      {
        params: ClinicParamsMapper.toPersistence(queryParams),
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'comma', encode: false })
        },
      },
    )

    return object
  }

  static async getProfessionalTypeListByHealthSupport(
    queryParams?: IQueryParams,
  ): Promise<IEnumResponse[]> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<IEnumResponse[]>>(
      `profissional/fila-atendimento/backoffice/enums/tipo-profissional`,
      {
        params: ClinicParamsMapper.toPersistence(queryParams),
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'comma', encode: false })
        },
      },
    )

    return object
  }

  static async getProfessionalList(
    queryParams?: IQueryParams,
  ): Promise<IEnumResponse[]> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<IEnumResponse[]>>(
      `profissional/agendamento/backoffice/autocomplete`,
      {
        params: ClinicParamsMapper.toPersistence(queryParams),
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'comma', encode: false })
        },
      },
    )

    return object.map(ProfessionalListMapper.toDomain)
  }

  static async getSpecialtyList(
    queryParams?: IQueryParams,
  ): Promise<SpecialtyListDataMapper[]> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<SpecialtyListData[]>>(
      `especialidade/agendamento/backoffice/listar/especialidades`,
      {
        params: ClinicParamsMapper.toPersistence(queryParams),
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'comma', encode: false })
        },
      },
    )

    return object.map(SpecialtyListMapper.toDomain)
  }

  static async submitScheduleAppointment(
    queryParams?: DataFormatted,
  ): Promise<IConexaResponsePageable<SubmitScheduleAppointment[]>> {
    const { data } = await coreApi.get<
      IConexaResponsePageable<SubmitScheduleAppointment[]>
    >(`unified-appointment/scheduled/list-availability/backoffice`, {
      params: SubmitScheduleAppointmentMapper.toPersistence(queryParams),
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'comma', encode: false })
      },
    })

    return data
  }

  static async createAppointment(
    data: CreateAppointmentDataDomain,
  ): Promise<void> {
    await coreApi.post(
      'atendimento-recorrente/agendar-paciente/backoffice',
      CreateAppointmentMapper.toPersistence(data),
    )
  }

  static async getHealthInsuranceList(
    queryParams?: IQueryParams,
  ): Promise<HealthInsuranceCardDataMapper[]> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<HealthInsuranceCardData[]>>(
      `paciente/agendamento/backoffice/health-insurance-cards`,
      {
        params: ClinicParamsMapper.toPersistence(queryParams),
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'comma', encode: false })
        },
      },
    )

    return object.map(HealthInsuranceCardMapper.toDomain)
  }

  static async getResponsibleList(): Promise<ResponsibleListDataMapper[]> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<ResponsibleListData[]>>(
      `atendimento/list/authorization-responsible`,
    )

    return object.map(ResponsibleListMapper.toDomain)
  }

  static async getQueueList(
    payload: GetAppointmentListMapper,
  ): Promise<AppointmentLogsListDataMapper[]> {
    const {
      data: { object },
    } = await coreApi.post(
      `fila/atendimento/listar/log`,
      AppointmentLogsListMapper.toPersistence(payload),
    )

    return object.map(AppointmentLogsListMapper.toDomain)
  }

  static async getPreQueueList(
    payload: GetAppointmentListMapper,
  ): Promise<AppointmentLogsListDataMapper[]> {
    const {
      data: { object },
    } = await coreApi.post(
      `pre/fila/atendimento/listar/log`,
      AppointmentLogsListMapper.toPersistence(payload),
    )

    return object.map(AppointmentLogsListMapper.toDomain)
  }

  static async getMedicalRecordList(
    queryParams?: IQueryParams,
  ): Promise<MedicalRecordListDataMapper[]> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<MedicalRecordData[]>>(
      `atendimento/list/appointments`,
      {
        params: MedicalRecordParamsMapper.toPersistence(queryParams),
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'comma', encode: false })
        },
      },
    )

    return object.map(MedicalRecordListMapper.toDomain)
  }

  static async getMedicalRecordProfessional(
    queryParams?: IQueryParams,
  ): Promise<MedicalRecordProfessionalFilterDataMapper[]> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<MedicalRecordProfessionalListData[]>>(
      `profissional/list/filter/professionals`,
      {
        params: queryParams,
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'comma', encode: true })
        },
      },
    )

    return object.map(MedicalRecordProfessionalFilterMapper.toDomain)
  }

  static async getMedicalRecordSpecialties(
    queryParams?: IQueryParams,
  ): Promise<MedicalRecordSpecialtiesListData[]> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<MedicalRecordSpecialtiesListData[]>>(
      `especialidade/list/filter/specialties`,
      {
        params: queryParams,
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'comma', encode: true })
        },
      },
    )

    return object
  }

  static async getMedicalRecordOutcomes(
    queryParams?: IQueryParams,
  ): Promise<IEnumResponse[]> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<IEnumResponse[]>>(
      `atendimento/list/filter/outcome`,
      {
        params: queryParams,
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'comma', encode: true })
        },
      },
    )

    return object
  }

  static async getMedicalRecordCouncils(
    queryParams?: IQueryParams,
  ): Promise<IEnumResponse[]> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<IEnumResponse[]>>(
      `atendimento/list/filter/councils`,
      {
        params: queryParams,
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'comma', encode: true })
        },
      },
    )

    return object
  }

  static async getMedicalRecordStatus(
    queryParams?: IQueryParams,
  ): Promise<IEnumResponse[]> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<IEnumResponse[]>>(
      `atendimento/list/filter/status`,
      {
        params: queryParams,
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'comma', encode: true })
        },
      },
    )

    return object
  }

  static async sendMedicalRecords(data: SendReportsPayload): Promise<void> {
    await coreApi.post(
      'medical-record/export',
      SendMedicalRecordsMapper.toPersistence(data),
    )
  }

  static async getMedicalRecordPdf(recordId: string): Promise<void> {
    const { data } = await coreApi.get(
      `medical-record/export-pdf/${recordId}`,
      {
        responseType: 'blob',
      },
    )

    downloadFiles(data, `prontuario-${recordId}`)
  }

  static async getMedicalReferralFiles(
    medicalReferralId: number,
    fileExtension: string,
  ): Promise<void> {
    const { data } = await coreApi.get(
      `medical-referral/download/${medicalReferralId}`,
      {
        responseType: 'blob',
      },
    )

    downloadFiles(
      data,
      `liberacao-plano-saude-${medicalReferralId}.${fileExtension}`,
    )
  }

  static async getExportLogList(
    queryParams?: IQueryParams,
  ): Promise<IConexaDataPageable<ExportLogsDataMapper[]>> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponsePageable<ExportLogsData[]>>(
      `medical-record/list-export`,
      {
        params: queryParams,
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'comma', encode: false })
        },
      },
    )

    return {
      data: object?.data?.map(ExportLogsListMapper.toDomain),
      total: object?.total,
    }
  }

  static async getExportLogDetails(
    exportLogId: string,
  ): Promise<ExportLogsDataMapper> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<ExportLogsData>>(
      `medical-record/export-detail/${exportLogId}`,
    )

    return ExportLogsListMapper.toDomain(object)
  }

  static async getMedicalReferralDetails(
    referralId: number,
  ): Promise<MedicalReferralDetailsDataMapper> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<MedicalReferralDetailsData>>(
      `/integration/admin/encaminhamento/v2/${referralId}`,
    )

    return MedicalReferralDetailsMapper.toDomain(object)
  }

  static async getCommunicationLogs(
    queryParams: CommunicationLogsSearchParams,
  ): Promise<GetCommunicationLogsResponse> {
    const {
      data: { object },
    } = await coreApi.post<IConexaResponse<CommunicationLogsResponse>>(
      'logs/comunicacao/filtrar',
      CommunicationLogsSearchMapper.toPersistence(queryParams),
    )

    return {
      data: object?.data?.map(CommunicationLogsDataMapper.toDomain),
      totalResults: object?.totalResults,
    }
  }

  static async getImmediateAppointments(
    queryParams: GetAppointmentsQueuesParams,
  ): Promise<ImmediateAppointmentQueueMapper> {
    const {
      data: { object },
    } = await coreApi.post(
      'fila/atendimento/listar/paginado',
      GetAppointmentsQueueListMapper.toPersistence(queryParams),
    )

    return {
      data: object?.data?.map(ImmediateAppointmentsQueueMapper.toDomain),
      totalResults: object?.total,
      hiddenCount: object?.totalOcultos ?? 0,
    }
  }

  static async getScheduledAppointments(
    queryParams: GetAppointmentsQueuesParams,
  ): Promise<ScheduledAppointmentQueueMapper> {
    const {
      data: { object },
    } = await coreApi.post(
      'pre/fila/atendimento/listar/paginado',
      GetAppointmentsQueueListMapper.toPersistence(queryParams),
    )

    return {
      data: object?.data?.map(ScheduledAppointmentsQueueMapper.toDomain),
      totalResults: object?.total,
    }
  }

  static async getProfessionalListAppointmentQueue(
    queryParams?: IQueryParams,
  ): Promise<ProfessionalListAppointmentQueueDataMapper[]> {
    const {
      data: { object },
    } = await coreApi.get<
      IConexaResponse<ProfessionalListAppointmentQueueData[]>
    >(`fila/atendimento/listar/profissionais`, {
      params: ClinicParamsMapper.toPersistence(queryParams),
      paramsSerializer: params => {
        return qs.stringify(params, { arrayFormat: 'comma', encode: false })
      },
    })

    return object.map(ProfessionalListAppointmentQueueMapper.toDomain)
  }

  static async createAppointmentQueue(
    payload: CreateAppointmentQueueData,
  ): Promise<void> {
    await coreApi.post(
      'fila/atendimento/incluir/paciente',
      CreateAppointmentQueueMapper.toPersistence(payload),
    )
  }

  static async assignProfessional(
    payload: AssignProfessionalDomainPayload,
  ): Promise<void> {
    await coreApi.post(
      'fila/atendimento/atribuir/profissional',
      AssignProfessionalMapper.toPersistence(payload),
    )
  }

  static async immediateRemoveAppointment(
    appointmentId: string,
  ): Promise<void> {
    await coreApi.get(`fila/atendimento/remover/${appointmentId}`)
  }

  static async immediateGenerateAccessCode(id: string): Promise<string> {
    const {
      data: { object },
    } = await coreApi.get(`fila/atendimento/gerar-codigo-acesso-rapido/${id}`)

    return object
  }

  static async scheduledGenerateAccessCode(id: string): Promise<string> {
    const {
      data: { object },
    } = await coreApi.get(
      `pre/fila/atendimento/gerar-codigo-acesso-rapido/${id}`,
    )

    return object
  }

  static async getHistoryAppointmentList(
    queryParams: HistoryAppointmentParamsMapper,
  ): Promise<IConexaDataPageable<HistoryAppointmentDataMapper[]>> {
    const {
      data: { object },
    } = await coreApi.post<IConexaResponsePageable<HistoryAppointmentData[]>>(
      'atendimento/filtrar-backoffice',
      HistoryAppointmentListMapper.toPersistence(queryParams),
    )

    return {
      data: object?.data?.map(HistoryAppointmentListMapper.toDomain),
      total: object?.total,
    }
  }

  static async getProfileList(): Promise<IEnumResponse[]> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<IEnumResponse[]>>(
      `atendimento/list/filter/scheduling-history/user-profile`,
    )

    return object
  }

  static async getForwardingList(
    params: ForwardingListParamsRaw,
  ): Promise<ForwardingDataItem[]> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<ForwardingDataItemRaw[]>>(
      `v1/conexa/tiss/encaminhamento/backoffice`,
      { params },
    )

    return ForwardingListMapper.toDomain(object)
  }

  static async confirmHistoryAppointment(
    payload: ConfirmAppointmentPayload,
  ): Promise<void> {
    await coreApi.post(
      'atendimento/confirmacao-consulta',
      ConfirmAppointmentMapper.toPersistence(payload),
    )
  }

  static async cancelHistoryAppointment({
    appointmentId,
    data,
  }: CancelHistoryAppointmentPayload): Promise<void> {
    await coreApi.put(
      `atendimento-recorrente/cancelar/${appointmentId}`,
      CancelHistoryAppointmentMapper.toPersistence(data),
    )
  }

  static async updaterContact({
    patientId,
    data,
  }: UpdaterContactPayload): Promise<void> {
    await coreApi.put(
      `user/patient/atualizar/email-celular/${patientId}`,
      ContactListMapper.toPersistence(data),
    )
  }

  static async getDocumentsListByPatient(
    appointmentId: number,
  ): Promise<ResendDocumentsDataMapper> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<ResendDocumentsData>>(
      `atendimento/buscar/quantidade/documentos/${appointmentId}`,
    )

    return ResendDocumentsMapper.toDomain(object)
  }

  static async resendDocuments(appointmentId: number): Promise<void> {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<void>>(
      `atendimento/enviar/documentos/${appointmentId}`,
    )

    return object
  }

  static async getImmediateAttachments(
    appointmentId: string,
  ): Promise<GetAttachmentsDataMapper> {
    const {
      data: { object },
    } = await coreApi.get(`fila/atendimento/obter-por-id/${appointmentId}`)

    return GetAttachmentsMapper.toDomain(object)
  }

  static async sendImmediateAttachment(payload: SendAttachment): Promise<void> {
    await coreApi.post('fila/atendimento/salvar/anexo', payload?.file, {
      headers: {
        idFilaAtendimento: payload?.id,
      },
    })
  }

  static async removeImmediateAttachment(
    data: RemoveAttachmentData,
  ): Promise<void> {
    await coreApi.get(
      `fila/atendimento/excluir/anexo/${data?.appointmentId}/${data?.attachmentId}`,
    )
  }

  static async getScheduledAttachments(
    appointmentId: string,
  ): Promise<GetAttachmentsDataMapper> {
    const {
      data: { object },
    } = await coreApi.get(`pre/fila/atendimento/obter-por-id/${appointmentId}`)

    return GetAttachmentsMapper.toDomain(object)
  }

  static async sendScheduledAttachment(payload: SendAttachment): Promise<void> {
    await coreApi.post('pre/fila/atendimento/salvar/anexo', payload?.file, {
      headers: {
        idPreFilaAtendimento: payload?.id,
      },
    })
  }

  static async removeScheduledAttachment(
    data: RemoveAttachmentData,
  ): Promise<void> {
    await coreApi.get(
      `pre/fila/atendimento/excluir/anexo/${data?.appointmentId}/${data?.attachmentId}`,
    )
  }

  static async scheduledRemoveAppointment(
    appointmentId: string,
  ): Promise<void> {
    await coreApi.get(`pre/fila/atendimento/remover/${appointmentId}`)
  }

  static async getAvailableHours(
    payload: AvailableHoursDataMapper,
  ): Promise<string[]> {
    const {
      data: { object },
    } = await coreApi.post(
      `profissional/agenda/horariosdisponiveis`,
      AvailableHoursMapper.toPersistence(payload),
    )

    return object
  }

  static async getAvailableHoursPV(
    payload: AvailableHoursDataMapper,
  ): Promise<AvailableHoursPVDataMapper[]> {
    const {
      data: { object },
    } = await coreApi.post(
      `profissional/agenda/pv/horarios`,
      AvailableHoursMapper.toPersistence(payload),
    )

    return object?.map(AvailableHoursPVMapper.toDomain)
  }

  static async rescheduleAppointment(
    payload: RescheduleAppointmentDataMapper,
  ): Promise<void> {
    await coreApi.post(
      `atendimento/reagendar`,
      RescheduleAppointmentMapper.toPersistence(payload),
    )
  }

  static async getPsyAliveList(
    clinicId: number,
    params: PsyAliveListParams,
  ): Promise<PsyAliveListResponse> {
    const { data } = await coreApi.get<IConexaResponse<PsyAliveListResponse>>(
      `/v1/backoffice/clinics/${clinicId}/professionals`,
      {
        params: {
          ...params,
          isPsychologistAlreadyMigrated: true,
        },
      },
    )

    return data?.object
  }

  static async getProfessionals(
    clinicId: number,
    params: ProfessionalsParams,
  ): Promise<ProfessionalsResponse> {
    const { data } = await coreApi.get<IConexaResponse<ProfessionalsResponse>>(
      `/v1/backoffice/clinics/${clinicId}/professionals`,
      {
        params: {
          ...params,
          ...(params?.professionalType === 'PSICOLOGO' && {
            isPsychologistAlreadyMigrated: true,
          }),
        },
      },
    )

    return data?.object
  }

  static async getPsychologistSchedule(params: UsePsyScheduleParams) {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<DaySlotSchedule[]>>(
      `/v1/backoffice/clinics/${params.clinicId}/professionals/${params.professionalId}`,
      {
        params: {
          ...params,
          isPsychologistAlreadyMigrated: true,
          professionalType: params.professionalType,
        },
      },
    )

    return object.map(PsyScheduleMapper.toDomain)
  }

  static async getProfessionalSchedule(params: ProfessionalScheduleParams) {
    const {
      data: { object },
    } = await coreApi.get<IConexaResponse<DaySlotProfessionalSchedule[]>>(
      `/v1/backoffice/clinics/${params.clinicId}/professionals/${params.professionalId}`,
      {
        params: {
          professionalType: params.professionalType || 'PSICOLOGO',
          ...params,
        },
      },
    )

    return object.map(PsyScheduleMapper.toDomain)
  }

  static async getProfessionalByPatientList(params: GetProfessionalByPatient) {
    const payload = MedicalRecordReportMapperTypes.toPersistence(params)
    const { data } = await coreApi.get<
      IConexaResponse<GetProfessionalByPatientResponse[]>
    >('/v1/profissional/profile', {
      params: payload,
    })

    return MedicalRecordReportMapperTypes.toDomain(data?.object)
  }

  static async getPatientReport(params: MedicalRecordReportFormData) {
    const payload = MedicalRecordReportDownloadMapper.toPersistence(params)
    const { data, headers } = await printoutAPI.post(
      '/printout-management/v1/hir/medical-records',
      payload,
      { responseType: 'blob' },
    )
    const blob = new Blob([data], {
      type: String(headers['content-type'] ?? ''),
    })
    downloadFiles(blob, `relatorio-paciente.pdf`)

    return true
  }

  static async getMedicalRecordPvivaPatientList(
    queryParams?: IQueryParams,
  ): Promise<PatientListDataMapper[]> {
    const { data } = await printoutAPI.get<PatientListData[]>(
      `/printout-management/v1/patient/autocomplete`,
      {
        params: ClinicParamsMapper.toPersistence(queryParams),
        paramsSerializer: params => {
          return qs.stringify(params, { arrayFormat: 'comma', encode: false })
        },
      },
    )
    return data.map(PatientListMapper.toDomain)
  }
}

export { TelemedicineServices }
